import React, { useState } from 'react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/solid'
import FlipbitText from '../assets/FlipbitText.svg'

function Navbar() {
  const [openMenu, setOpenMenu] = useState(false)

  const handleMenuToggle = () => {
    setOpenMenu(!openMenu)
  }

  return (
    <nav className="bg-white shadow-sm fixed w-full">
      <div className="container mx-auto px-8 py-4 flex items-center justify-between">
        {/* Left Side - Brand */}
        <button
          onClick={() => (window.location.href = '/')}
          className="text-2xl md:text-3xl font-light text-blue-light dark:text-blue-dark tracking-widest"
        >
          <img src={FlipbitText} className="h-10 pointer-events-none" alt="logo" />
        </button>

        {/* Desktop Tabs */}
        <div className="hidden md:flex space-x-6">
          <a href="#about" className="text-black  text-lg hover:text-blue-700">
            About
          </a>
        </div>

        {/* Mobile Menu Icon */}
        <button onClick={handleMenuToggle} className="md:hidden text-gray-600 focus:outline-none">
          {openMenu ? (
            <XMarkIcon className="h-7 w-7 stroke-2 text-black" />
          ) : (
            <Bars3Icon className="h-7 w-7 stroke-2 text-black" />
          )}
        </button>
      </div>

      {/* Mobile Dropdown Menu */}
      {openMenu && (
        <div className="md:hidden bg-gray-100">
          <a
            href="#about"
            className="block py-2 px-4 text-black  text-lg hover:text-blue-700"
            onClick={() => setOpenMenu(false)}
          >
            About
          </a>
        </div>
      )}
    </nav>
  )
}

export default Navbar
